<template>
  <div id="footer">
    <p>
      Copyright&nbsp;&nbsp;©&nbsp;&nbsp;广州市金界电子设备有限公司 &nbsp;&nbsp;
      <a href="http://www.beian.miit.gov.cn">粤ICP备19060835号-1</a>
    </p>
    <p>
      <a href></a>
    </p>
  </div>
</template>
<style scoped>
#footer {
  width: 100%;
  height: 80px;
  background-color: rgb(56, 60, 75);
  color: rgb(255, 255, 255);
  font-size: 14px;
  text-align: center;
  line-height: 80px;
}
a {
  color: #fff;
}
</style>
<script>
export default {
  name: "footer",
  data() {
    return {};
  },
  methods: {}
};
</script>




// WEBPACK FOOTER //
// src/components/page_footer.vue